import { render, staticRenderFns } from "./SearchSanID.vue?vue&type=template&id=57f05dc5&"
import script from "./SearchSanID.vue?vue&type=script&lang=ts&"
export * from "./SearchSanID.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports